import { TEmailAlert, TTimeInStatus } from "~/types/model";
import OrderNotary from "./orderNotary";

export default class Order {

  id!: number;
  status!: number;
  statusName!: string;
  dealershipInitials!: string;
  userId!: number;
  schedulerId!: number;
  customerLocation!: number;
  isVidRequired!: boolean;
  isEsignRequired!: boolean;
  isInkSignRequired!: boolean;
  isNotaryRequired!: boolean;
  isRushRequired!: boolean;
  isMavPrimeRequired!: boolean;
  isSameDayCompletionRequired!: boolean;
  isAoiThumbprintRequired!: boolean;
  isInsuranceVerificationRequired!: boolean;
  canChangeSigningLocation!: boolean;
  hasMavShippingLabel!: boolean;
  docDeliveryOption!: number;
  isFleet!: boolean | null;
  notaryMustUploadDocs!: boolean;
  caDeliveryForm!: number;
  sealStatus!: number | null;
  sealerId!: number | null;
  timeInStatus!: TTimeInStatus;
  signer1Instructions!: string | null;
  signer2Instructions!: string | null;
  isNotarySearchExhausted!: boolean | null;
  dealerAccountingNotes!: string | null;
  accountingStatus!: number;
  cancellationReason!: string | null;
  isRural!: boolean | null;
  dealerInstructions!: string | null;
  accountingComment!: string | null;
  dealerStoreId!: number;
  onHoldReviewStatus!: number | null;
  onHoldReviewReason!: string | null;
  underReviewStatus!: number | null;
  underReviewReason!: string | null;
  accountingReviewStatus!: number | null;
  accountingReviewReason!: string | null;
  duplicateReviewStatus!: number | null;
  duplicateReviewReason!: string | null;
  cancellationComment!: string | null;
  r1DealJacketId!: number | null;
  notaryBiddingStatus!: number;
  isGuaranteeRequired!: number;
  isSecureOffsiteRequired!: number;
  isSameCarDeliveryAddress!: boolean | null;
  isAoiOnly!: boolean;
  secondFormOfId!: string | null;
  dealerStatementId!: number | null;
  paymentId!: number | null;
  dealerRegionId!: number | null;
  dealerGroupId!: number;
  userPhone!: string;
  userEmail!: string;
  userImage!: string;
  schedulerEmail!: string | null;
  schedulerPhone!: string | null;
  schedulerImage!: string | null;
  customerPhone!: string;
  customerFirstName!: string;
  customerLastName!: string;
  userFullName!: string;
  dealerStorePhone!: string | null;
  dealerStoreName!: string;
  dealerStoreHasNewPaymentPlanModel!: number;
  dealerGroupName!: string;
  dealerGroupSpecialInstructions!: string | null;
  dealerGroupSpecialInstructionsAppliesTo!: string | null;
  dealerStoreAddress!: string | null;
  dealerStoreState!: string;
  dealerStoreCity!: string | null;
  generalManagerName!: string | null;
  generalManagerEmail!: string | null;
  dealerStoreZip!: string | null;
  schedulerFullName!: string;
  sealerFullName!: string | null;
  customerName!: string;
  isInactive!: boolean;
  carrier!: number;
  mavShippingLabelStatus!: number;
  mavOutgoingPickupOption!: string | null;
  mavOutgoingDocsSentPickupInfo!: any | null;
  outgoingShippingLabel!: string | null;
  outgoingShippingAwb!: string | null;
  returnShippingLabel!: string | null;
  returnShippingAwb!: string | null;
  returnCarrier!: number;
  orderNotary!: OrderNotary | null;
  granularStatus!: string;
  vidStatus!: number;
  vidRequestRetriesLeft!: number;
  vidRequest2RetriesLeft!: number | null;
  canAmendDealerAmount!: boolean;
  canIgnoreAccounting!: boolean;
  isExistingCustomer!: boolean;
  servicesAreSelected!: boolean;
  userEmailAlert!: TEmailAlert | null;
  completedTs!: number | null;
  forceCompleteNotifiedTs!: number | null;
  termsAcceptedTs!: number;
  notaryBiddingUpdatedTs!: number;
  schedulerAssignedTs!: number;
  submittedTs!: number | null;
  statusChangedTs!: number;
  sealedTs!: number | null;
  createdTs!: number;
  updatedTs!: number;

  static STATUS_CANCELLED = -1;
  static STATUS_DRAFT = 0;
  static STATUS_PENDING_VID = 1;
  static STATUS_PENDING_INSURANCE_VERIFICATION = 2;
  static STATUS_PENDING_SECOND_FORM_OF_ID = 3;
  static STATUS_NEW = 4;
  static STATUS_PICK_NOTARY = 5;
  static STATUS_GENERATE_SHIPPING_LABEL = 6;
  static STATUS_PENDING_E_SIGN = 7;
  static STATUS_PENDING_INK_SIGN = 8;
  static STATUS_COMPLETED = 9;
  static STATUS_SEALED = 10;

  static CUSTOMER_LOCATION_REMOTE = 1;
  static CUSTOMER_LOCATION_IN_STORE = 2;

  static CONTRACT_OPTION_VID = 1;
  static CONTRACT_OPTION_SIGNING_VID = 2;
  static CONTRACT_OPTION_SIGNING = 3;

  static DOC_DELIVERY_OPTION_UPLOAD = 1;
  static DOC_DELIVERY_OPTION_SHIPPING = 2;

  static SEAL_STATUS_QUEUED = 1;
  static SEAL_STATUS_FAILED = 2;
  static SEAL_STATUS_SEALED = 3;

  static CONTRACT_TYPE_ORIGINAL = 1;
  static CONTRACT_TYPE_RESIGN = 2;

  static UI_GRID_VIEW = "grid";
  static UI_LIST_VIEW = "list";

  static MAV_SHIPPING_LABEL_STATUS_NEW = 1;
  static MAV_SHIPPING_LABEL_STATUS_CREATED = 2;
  static MAV_SHIPPING_LABEL_STATUS_CANCEL = 3;

  static CA_DELIVERY_FORM_NO = 0;
  static CA_DELIVERY_FORM_YES = 1;
  static CA_DELIVERY_FORM_YES_BOTH_CONTRACTS = 2;

  static ACCOUNTING_STATUS_NOT_SETTLED = 0;
  static ACCOUNTING_STATUS_SETTLED = 1;
  static ACCOUNTING_STATUS_IGNORED = 2;

  static getStatusColor(status: number) {
    switch (status) {
      case this.STATUS_CANCELLED:
        return 'danger';
      case this.STATUS_DRAFT:
        return 'warning';
      case this.STATUS_NEW:
        return 'primary';
      case this.STATUS_PENDING_SECOND_FORM_OF_ID:
      case this.STATUS_PENDING_VID:
      case this.STATUS_PENDING_E_SIGN:
      case this.STATUS_PENDING_INK_SIGN:
      case this.STATUS_SEALED:
        return 'info';
      case this.STATUS_COMPLETED:
        return 'success';
      default:
        return 'dark';
    }
  }

  static getStatusMap() {
    return {
      [this.STATUS_CANCELLED]: 'Canceled',
      [this.STATUS_DRAFT]: 'Draft',
      [this.STATUS_PENDING_VID]: 'Pending VID',
      [this.STATUS_NEW]: 'New Order',
      [this.STATUS_PENDING_SECOND_FORM_OF_ID]: 'Pending Customer 2nd ID',
      [this.STATUS_PICK_NOTARY]: 'Pick Notary',
      [this.STATUS_GENERATE_SHIPPING_LABEL]: 'Generate Label',
      [this.STATUS_PENDING_E_SIGN]: 'Pending E-sign',
      [this.STATUS_PENDING_INK_SIGN]: 'Pending Ink-sign',
      [this.STATUS_COMPLETED]: 'Completed',
      [this.STATUS_SEALED]: 'Sealed',
    };
  }

  static getStatusName(id: number) {
    return this.getStatusMap()[id];
  }

  static getCustomerLocations() {
    return {
      [this.CUSTOMER_LOCATION_REMOTE]: 'Remote',
      [this.CUSTOMER_LOCATION_IN_STORE]: 'In store',
    };
  }

  static getContractOptions() {
    return {
      [this.CONTRACT_OPTION_VID]: 'Identity Verification only',
      [this.CONTRACT_OPTION_SIGNING_VID]: 'Contract Signing with Identity Verification',
      [this.CONTRACT_OPTION_SIGNING]: 'Contract Signing only',
    };
  }

  static getContractTypeMap() {
    return {
      [this.CONTRACT_TYPE_ORIGINAL]: 'Original - Complete document package for signing',
      [this.CONTRACT_TYPE_RESIGN]: 'Resign - 1 or 2 documents that need resigning',
    };
  }

  static getContractTypeName(id: number) {
    return this.getContractTypeMap()[id];
  }

  static getDocDeliveryOptions() {
    return {
      [this.DOC_DELIVERY_OPTION_UPLOAD]: 'Upload',
      [this.DOC_DELIVERY_OPTION_SHIPPING]: 'Shipping',
    };
  }

  static getDocDeliveryOptionName(id: number) {
    return this.getDocDeliveryOptions()[id];
  }

  static getNotaryOptions() {
    return {
      1: 'Yes, I need a notary to assist the signing',
      0: 'No',
    };
  }

  static getRushOrderOptions() {
    return {
      1: 'Yes - striving for a completion time between 24 to 48 hours',
      0: 'No - striving for a completion time between 3 to 5 working days',
    };
  }

  static getCalifornia448SpecialInstruction() {
    return {
      [this.CA_DELIVERY_FORM_YES_BOTH_CONTRACTS]: "Note to notary: this order requires two separate signings,each with its own fee. The first signing involves the standard document package, which the customer will sign in the presence of a notary. The second signing will occur at the time of vehicle delivery, where the notary will assist in completing a 448 form alongside the delivery driver and the customer. The delivery date and time will be arranged after the initial appointment, and you will receive confirmation for the second appointment before the delivery takes place.",
      [this.CA_DELIVERY_FORM_YES]: "Note to notary: this signing will take place with the delivery driver and the customer at the time the vehicle is delivered. The delivery date and time will take place the same day as this lead or within 24 hours. Please accept this lead if you're available."
    };
  }
}